import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, functions } from "../firebase";
import { ActionItem, Interaction, MeetingData } from "../models";
import { getAuth } from "firebase/auth";
import { httpsCallable } from "firebase/functions";

export const fetchInteractionById = async (
  interactionId: string
): Promise<Interaction | null> => {
  const docRef = doc(db, "interactions", interactionId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data() as Interaction;
  } else {
    console.log("No such document!");
    return null;
  }
};

export const saveMeetingSummary = async (
  interactionId: string,
  meetingData: MeetingData,
  meetingTranscript: string
): Promise<void> => {
  const docRef = doc(db, "interactions", interactionId);
  await updateDoc(docRef, {
    meetingSummary: meetingData.summary,
    keyMoments: meetingData.keyMoments,
    meetingTranscript: meetingTranscript, // Save the meeting transcript
  });
};

export const deleteInteraction = async (
  interactionId: string
): Promise<void> => {
  const docRef = doc(db, "interactions", interactionId);
  await deleteDoc(docRef);
};

export const generateMeetingSummary = async (file: File) => {
  if (file) {
    try {
      const fileContent = await file.text();

      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("User is not logged in.");
        return;
      }

      await currentUser.getIdToken(true); // Force refresh the token

      const processMeeting = httpsCallable(functions, "processMeetingFlow");

      try {
        const result = await processMeeting({
          meetingTranscript: fileContent,
        });
        //   setMeetingData(result.data as MeetingData);
        //   setFile(null);
        //   if (fileInputRef.current) {
        //     fileInputRef.current.value = "";
        //   }

        return result.data as MeetingData;
      } catch (error: any) {
        console.error("Error calling processMeetingFlow:", error);
        return error;
      }
    } catch (error) {
      console.error("Error processing file:", error);
      return error;
    }
  }
};
export const generateActionItems = async (file: File) => {
  if (file) {
    try {
      const fileContent = await file.text();

      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("User is not logged in.");
        return;
      }

      await currentUser.getIdToken(true); // Force refresh the token

      const extractActionItems = httpsCallable(functions, "extractActionItems");

      try {
        const result = await extractActionItems({
          meetingTranscript: fileContent,
        });
        //   setMeetingData(result.data as MeetingData);
        //   setFile(null);
        //   if (fileInputRef.current) {
        //     fileInputRef.current.value = "";
        //   }

        const data = result.data as { actionItems: ActionItem[] };
        return data.actionItems;
      } catch (error: any) {
        console.error("Error calling processMeetingFlow:", error);
        return error;
      }
    } catch (error) {
      console.error("Error processing file:", error);
      return error;
    }
  }
};
export const generateEmail = async (file: File) => {
  if (file) {
    try {
      const fileContent = await file.text();

      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("User is not logged in.");
        return;
      }

      await currentUser.getIdToken(true); // Force refresh the token

      const extractSummaryEmail = httpsCallable(
        functions,
        "extractSummaryEmail"
      );

      try {
        const result = await extractSummaryEmail({
          meetingTranscript: fileContent,
        });
        //   setMeetingData(result.data as MeetingData);
        //   setFile(null);
        //   if (fileInputRef.current) {
        //     fileInputRef.current.value = "";
        //   }

        const data = result.data as { emailTemplate: string };
        return data.emailTemplate;
      } catch (error: any) {
        console.error("Error calling processMeetingFlow:", error);
        return error;
      }
    } catch (error) {
      console.error("Error processing file:", error);
      return error;
    }
  }
};
